export default {
  reportConversion() {
    try {
      window.rc.conversionHit({
        id: 100204327,
        value: null,
        consent: ~~window.localStorage.getItem('cookies.marketing')
      });
    } catch {}
  }
};
